import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "./api";
const USE_LIST_NOTIFICATIONS = "useListNotifications";
export const useMarkNotificationAsRead = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (notificationId) => {
            await api.put(`/notifications/${notificationId}/mark-as-read/`);
        },
        onSuccess: () => {
            queryClient.invalidateQueries([USE_LIST_NOTIFICATIONS]);
        },
        onError: () => { },
    });
};
export const useListNotifications = ({ page = 1 }) => {
    return useQuery({
        queryKey: [USE_LIST_NOTIFICATIONS, page],
        refetchOnWindowFocus: true,
        staleTime: 30000,
        queryFn: async () => {
            const response = await api.get("/notifications/", { params: { page } });
            return response.data;
        },
    });
};
